"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _FullBar = _interopRequireDefault(require("../baseComponents/FullBar"));
var _Button = _interopRequireDefault(require("../baseComponents/Button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TextTile = function TextTile(props) {
  var modalClasses = (0, _classnames["default"])("tile-component", "text-tile");
  var footerBarElementsLeft = [];
  var footerBarElementsRight = [];
  props.footer.buttonProps && footerBarElementsRight.push(/*#__PURE__*/_react["default"].createElement(_Button["default"], props.footer.buttonProps));
  props.footer.icon && footerBarElementsLeft.push(/*#__PURE__*/_react["default"].createElement(_Icons["default"], props.footer.icon));
  props.footer.text && footerBarElementsLeft.push(/*#__PURE__*/_react["default"].createElement("div", {
    className: "mice"
  }, props.footer.text));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses,
    onClick: props.onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mainContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "headerContainer",
    "data-value": props.value
  }, props.header.icon ? /*#__PURE__*/_react["default"].createElement(_Icons["default"], props.header.icon) : null, /*#__PURE__*/_react["default"].createElement("div", null, props.header.text)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "contentContainer"
  }, props.content.title && /*#__PURE__*/_react["default"].createElement("h5", null, props.content.title), props.content.desc && /*#__PURE__*/_react["default"].createElement("p", null, props.content.desc), props.content.details && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mice details"
  }, props.content.details)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
    right: footerBarElementsRight,
    left: footerBarElementsLeft
  }))));
};
TextTile.propTypes = {
  footer: _propTypes["default"].shape({
    buttonProps: _propTypes["default"].any,
    icon: _propTypes["default"].string,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  }),
  content: _propTypes["default"].shape({
    details: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    desc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  }),
  header: _propTypes["default"].shape({
    icon: _propTypes["default"].string,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  })
};
TextTile.defaultProps = {
  footer: {},
  content: {},
  header: {}
};
var _default = exports["default"] = TextTile;